const path = "/ava/questionario";

const quastionarioRoutes = {
  main: `${path}`,
  cloanar: `${path}/clonar`,
  abertos: `${path}/abertos`,
};

export default quastionarioRoutes;
